import React, { useEffect, useState } from "react";
import { useStaticQuery, graphql, Link, withPrefix } from "gatsby";

import "./PopularPosts.scss";
import { shuffleArray } from "../../../utils/arrayUtilities";
import { dateToRelativeFormat } from "../../../utils/dateToRelativeFormat";

const PopularPosts = () => {
  const [posts, setPosts] = useState<any>([]);
  const data = useStaticQuery(graphql`
    query data2 {
      allContentfulHome {
        nodes {
          referenciaSubcategorias {
            titulo
            slug
            referenciaSubcategorias {
              titulo
              slug
              tipoContenido
              createdAt
              referenciaInterna {
                referenciaCabecera {
                  imagenHeader {
                    file {
                      url
                    }
                  }
                  tituloPrincipal
                }
              }
            }
          }
        }
      }
    }
  `);

  useEffect(() => {
    if(!data.allContentfulHome?.nodes[0]?.referenciaSubcategorias) return;
    const process = shuffleArray(
      data.allContentfulHome.nodes[0].referenciaSubcategorias
        .map((node) => {
          const articles = node.referenciaSubcategorias
            ?.filter((item) => item.tipoContenido === "Articulo")
            .map((item) => ({ ...item, slug: node.slug + item.slug }));
          return articles;
        })
        .filter((item) => (item ? item.length >= 1 : false))
        .flat()
        .map((item) => ({
          slug: item.slug,
          titulo: item.referenciaInterna.referenciaCabecera.tituloPrincipal,
          imagen:
            item.referenciaInterna.referenciaCabecera.imagenHeader.file.url,
          fecha: dateToRelativeFormat(item.createdAt),
        }))
    );
    setPosts(process.slice(0, 3));
  }, []);

  return (
    <div className="popular-posts">
      <div className="popular-posts__title">
        <h3>Entradas populares</h3>
      </div>
      {posts.map((post, key) => (
        <Link to={withPrefix(post.slug)} key={key}>
          <div className="popular-posts__content">
            <div className="popular-posts__items">
              <img src={post.imagen} alt="" />
              <div className="popular-posts__items-content">
                <div className="popular-posts__items-title">
                  <h3>{post.titulo}</h3>
                </div>
                <div className="popular-posts__items-date">
                  <span>{post.fecha}</span>
                </div>
              </div>
            </div>
          </div>
        </Link>
      ))}
    </div>
  );
};

export default PopularPosts;
